// Author YuJiaBei
// Date 2023-08-09 16:39:51

import * as model from "@/model/sithMes/prd/SithMesPrdPpOperationModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {customVuexFilterPatternFactory} from "@/store/em/commonPattern/customVuexFilterPatternFactory";
import {customVuexVoPatternFactory} from "@/store/em/commonPattern/customVuexVoPatternFactory";
import {customVuexEntityPatternFactory} from "@/store/em/commonPattern/customVuexEntityPatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesPrdPpOperation(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_PRD_URL,
        selectRowsToItems: function (row) {
            return {value: row.id, text: row.operationSeq}
        },
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'schedulingFilter',
        filterInitializer: newFilter
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'dispatchFilter',
        filterInitializer: newFilter
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'executeFilter',
        filterInitializer: newFilter
    })
    .withPatternFactory(customVuexEntityPatternFactory, {
        entityState: 'executeEntity',
        entityConstructor: model.SithMesPrdPpOperation
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'schedulingVo'
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'dispatchVo'
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'executeVo'
    })
    .buildStore()
